if (!customElements.get('jc-other-wines')) {
  customElements.define(
    'jc-other-wines',
    class JCOtherWines extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.jc-other-wines__track');
        this.cards = this.querySelectorAll('.jc-other-wines__card');
        this.tabs = this.querySelectorAll('.jc-other-wines__tab-input');
        this.prevBtn = this.querySelector('[data-carousel-prev]');
        this.nextBtn = this.querySelector('[data-carousel-next]');

        this.handleTabChange = this.handleTabChange.bind(this);
        this.tabs.forEach((input) => input.addEventListener('change', this.handleTabChange));

        this.prevBtn?.addEventListener('click', () => this.scrollByCard(-1));
        this.nextBtn?.addEventListener('click', () => this.scrollByCard(1));

        this.filterByCategory();
      }

      handleTabChange() {
        this.filterByCategory();
        this.track.scrollTo({ left: 0, behavior: 'smooth' });
      }

      filterByCategory() {
        const activeTab = [...this.tabs].find((input) => input.checked);
        const activeCategory = activeTab ? activeTab.value : '';

        this.cards.forEach((card) => {
          card.hidden = activeCategory !== '' && card.dataset.category !== activeCategory;
        });
      }

      scrollByCard(direction) {
        const card = [...this.cards].find((card) => !card.hidden);
        if (!card || !this.track) return;

        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        this.track.scrollBy({ left: direction * (card.offsetWidth + gap), behavior: 'smooth' });
      }
    }
  );
}
